var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1865 4H18.1791V3C18.1791 2.45 17.7259 2 17.1718 2C16.6178 2 16.1645 2.45 16.1645 3V4H8.10602V3C8.10602 2.45 7.65273 2 7.09871 2C6.54469 2 6.0914 2.45 6.0914 3V4H5.08408C3.96597 4 3.07953 4.9 3.07953 6L3.06946 20C3.06946 21.1 3.96597 22 5.08408 22H19.1865C20.2945 22 21.2011 21.1 21.2011 20V6C21.2011 4.9 20.2945 4 19.1865 4ZM19.1865 19C19.1865 19.55 18.7332 20 18.1791 20H6.0914C5.53737 20 5.08408 19.55 5.08408 19V9H19.1865V19ZM7.09871 11H9.11333V13H7.09871V11ZM11.128 11H13.1426V13H11.128V11ZM15.1572 11H17.1718V13H15.1572V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRange);
export default __webpack_public_path__ + "static/media/dateRange.1f44fa23faab911c6c284e7b64678693.svg";
export { ForwardRef as ReactComponent };